const itemDataParamsListActions = {
  ITEM_DATA_PARAMS_LIST_SET: 'ITEM_DATA_PARAMS_LIST_SET'
};
export default itemDataParamsListActions;
